// Libs
import classNames from 'classnames/bind';
import { Spinner } from '@instructure/ui';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './Loading.module.scss';

type LoadingProps = {
  loading?: boolean;
  overlay?: boolean;
};

const cx = classNames.bind(styles);

const Loading = (props: LoadingProps) => {
  //#region Destructuring Props
  const { loading = true, overlay = false } = props;
  //#endregion Destructuring Props

  return (
    <div id='loadingComponent'>
      {loading && (
        <div className={cx('loadingContainer', overlay ? 'overlay' : 'noOverlay')}>
          <Spinner renderTitle='Loading' size='small' />
        </div>
      )}
    </div>
  );
};

export default Loading;
